<template>
	<div style="font-family: monospace;">

		<div v-for="(value, key) in data">
			<strong>{{ key }}</strong>
			<template v-if="typeof value == 'object'">
				<div class="padding-left">
					<Json :data="value" />
				</div>
			</template>
			<template v-else>
				{{ value }}
			</template>
		</div>

	</div>
</template>

<script>
export default {
  name: 'Json',
  props: [
    'data'
  ]
}
</script>
